<template>
  <my-dialog
    @hideMask="$emit('update:deleteDialogFlag', false)"
    :dialogFlag="deleteDialogFlag"
    width="400px"
    p_lr="0"
    borderRadius="8px"
    :hideMaskFlag="false"
    :clickMaskForHide="true"
  >
    <div class="dialog_container">
      <div class="dialog_container_header">
        <h3 class="header_title">删除</h3>
        <div class="close_btn" @click="$emit('update:deleteDialogFlag', false)">
          <img
            src="//image.zhihuishu.com/zhs/ablecommons/zhangying/202110/322b44f4a1e34d8cb527d1e033ec659b.png"
            alt="关闭"
          />
        </div>
      </div>
      <div class="dialog_container_body">
        <img class="delete_icon" :src="deleteIcon" alt="删除" />
        <p class="delete_title">是否确认要删除当前{{ userType }}？</p>
      </div>
      <div class="dialog_container_footer">
        <div class="cancel_btn" @click="$emit('update:deleteDialogFlag', false)">取消</div>
        <div class="confirm_btn" @click="handleConfirm">删除</div>
      </div>
      <div class="loading_mask" v-if="dialogLoading">
        <a-spin />
      </div>
    </div>
  </my-dialog>
</template>

<script>
export default {
  name: 'PersonnelDialog',
  components: {
    'my-dialog': () => import('@/components/my_dialog')
  },
  data() {
    return {
      dialogLoading: false
    }
  },
  props: {
    personnelType: {
      type: Number | String,
      default: ''
    },
    deleteDialogFlag: {
      type: Boolean,
      default: false
    },
    rowDetail: {
      type: Object,
      default: {}
    }
  },
  computed: {
    deleteIcon: function () {
      //
      let res = ''
      switch (this.personnelType) {
        case 0:
          res = require('@/assets/img/personnel/delete.png')
          break
        case 1:
        case 2:
          res = require('@/assets/img/personnel/delete02.png')
          break
      }
      return res
    },
    userType: function () {
      let res = ''
      switch (this.personnelType) {
        case 0:
          res = '用户'
          break
        case 1:
          res = '管理员'
          break
        case 2:
          res = '助教'
          break
      }
      return res
    }
  },
  methods: {
    async handleConfirm() {
      try {
        this.dialogLoading = true
        let apiName = ''
        if (!this.personnelType) {
          apiName = 'userDelete'
        }
        if (this.personnelType === 1) {
          apiName = 'adminDelete'
        }
        if (this.personnelType === 2) {
          apiName = 'assistantDelete'
        }
        const result = await this.$http[apiName]({ userId: this.rowDetail.userId })
        this.dialogLoading = false
        if (result.code !== 200) return this.$message.error(result.msg)
        const { rt: resultReally } = result
        this.$emit('update:deleteDialogFlag', false)
        if (resultReally.resultStatus !== 1)
          return this.$message.error(resultReally.resultMessage ? resultReally.resultMessage : '删除失败')
        this.$message.success('删除成功')
        this.$emit('getPersonnelList')
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog_container {
  position: relative;
  .dialog_container_header {
    width: 100%;
    height: 60px;
    border-radius: 8px 8px 0 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 30px;
    border-bottom: 1px solid #eaeaea;
    .header_title {
      font-size: 16px;
      font-weight: 500;
      color: #1e2228;
    }
    .close_btn {
      width: 12px;
      height: 12px;
      cursor: pointer;
      img {
        width: 100%;
        height: 100%;
        display: block;
      }
    }
  }
  .dialog_container_body {
    width: 100%;
    height: 250px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    .delete_icon {
      width: 120px;
      height: 120px;
      display: block;
    }
    .delete_title {
      font-size: 16px;
      color: #0c0b22;
      margin-top: 20px;
    }
  }
  .dialog_container_footer {
    width: 100%;
    height: auto;
    padding: 20px 0;
    border-top: 1px solid #eaeaea;
    display: flex;
    justify-content: center;
    .cancel_btn,
    .confirm_btn {
      width: 104px;
      height: 38px;
      border-radius: 5px;
      font-size: 12px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      user-select: none;
      box-shadow: 0 0 5px #f5f5f5;
      letter-spacing: 1px;
    }
    .cancel_btn {
      border: 1px solid #5f60d3;
      color: #5f60d3;
      background-color: #fff;
      margin-right: 16px;
      &:hover {
        background-color: #f5f5f5;
      }
      &:active {
        background-color: #fff;
      }
    }
    .confirm_btn {
      background-color: #ed5959;
      color: #fff;
      &:hover {
        background-color: #cd4b4b;
      }
      &:active {
        background-color: #ed5959;
      }
    }
  }
}
.loading_mask {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.7);
  cursor: not-allowed;
}
</style>
